import { useEffect } from 'react';
import dayjs from 'dayjs';
import { useScheduleBoardContext } from 'pos-client/components/scheduleBoard/context/ScheduleBoardContext.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useNonTradingDates = () => {
  const { selectedLocation, selectedDate, setIsNonTradingDate } =
    useScheduleBoardContext();

  const { data: nonTradingDates, refetch: refetchNonTradingDates } =
    trpc.getAllNonTradingDates.useQuery(
      {
        id: selectedLocation?.openingHoursGroupId as string,
      },
      {
        enabled: !!selectedLocation?.openingHoursGroupId,
      }
    );

  useEffect(() => {
    const isNonTradingDate = nonTradingDates
      ? nonTradingDates.some((item) =>
          dayjs(selectedDate).isSame(new Date(item.date), 'day')
        )
      : false;

    isNonTradingDate ? setIsNonTradingDate(true) : setIsNonTradingDate(false);
  }, [selectedDate, nonTradingDates, selectedLocation]);

  return { nonTradingDates, refetchNonTradingDates };
};
